//计算属性
export default{
	  systemData: state => {
	      return state.systemData
	    },
		Login: state=>{
			return state.Login
		},
		Query: state=>{
			return state.Query
		},
		Search: state=>{
			return state.Search
		}
}